<template>
  <div>
    <a-modal
      v-model="visible"
      title="导出数据表格"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      :getContainer="getContainer"
    >
      <div style="display: flex; justify-content: center; flex-wrap: wrap">
        <a-checkbox-group v-model="checkedList" @change="onChange">
          <div class="item">
            基本信息
            <a-checkbox value="1"></a-checkbox>
          </div>
          <div class="item">
            个人承诺书
            <a-checkbox value="2"></a-checkbox>
          </div>
          <div class="item">
            三级教育卡
            <a-checkbox value="3"></a-checkbox>
          </div>
          <div class="item">
            劳动合同
            <a-checkbox value="4"></a-checkbox>
          </div>
          <div class="item">
            试卷
            <a-checkbox value="5"></a-checkbox>
          </div>
          <div class="item">
            入场安全教育档案（普工）
            <a-checkbox value="7"></a-checkbox>
          </div>
          <div class="item" v-for="v in blank_list" :key="v.id">
            {{ v.title }}
            <a-checkbox :value="'6-' + v.id"></a-checkbox>
          </div>
          <div style="text-align: center; padding-top: 20px" v-if="loading">
            <a-spin tip="获取空白模板..." />
          </div>
        </a-checkbox-group>
      </div>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    blank_list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      visible: false,
      checkedList: [],
    };
  },
  methods: {
    init() {
      // this.checkedList = ["1", "2", "3", "4", "5"];
      this.checkedList = ["7"];
      this.visible = true;
    },
    onChange(e) {
      console.log(e);
    },
    handleOk() {
      this.$emit("confirmExport", this.checkedList);
      this.visible = false;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style scoped>
.item {
  width: 420px;
  height: 56px;
  background: #ffffff;
  box-shadow: 0px 4px 10px #e6e8f0;
  border-radius: 10px;
  margin: 15px auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>